import React from 'react';
import { useLocaleContext } from '../../../../context/LocaleContext';
import { replaceHost } from '../../../../helpers/replace-host';

import './style.scss';

/**
 * 
 * @param {object} partner Partner info
 * @param {string} size Size of logo. Default sm. Values: xxl (290x290), lg (174x174), md (140x140), sm (80x80)
 * @param {boolean} base Boolean value for display square logo or base preview logo with 70x24 size
 * @param {function} onClick Click callback
 * @returns {ReactComponent}
 */

const PartnerLogo = ({partner, size = 'sm', base = false, onClick}) => {
    const $locale = useLocaleContext();

    function handleOnClick(e) {
        if (!!partner.link === false) {
            e.preventDefault();

            onClick(partner);
        }
    }

    return (
        <a
            href={!!partner.link ? partner.link : ''}
            className={`partner-logo partner-logo--${size} partner-logo--${base ? 'base' : 'square'}`}
            target={!!partner.link ? '_blank' : '_self'}
            onClick={handleOnClick}
        >
            <img
                src={replaceHost(partner.logoUrl)}
                alt={$locale.getProperty(partner, 'title')}
            />
        </a>
    )
};

export default PartnerLogo;
